import { create } from 'zustand';
import { ApiUtils, MessagesApi, MessageThreadEntity, RequestStrategyEnum } from '@shared/api';
import { PermissionsUtils } from '@shared';

interface IThreadsStore {
  loading: boolean;
  error: string | null;
  threads: MessageThreadEntity[];
  getThreads: (signal?: AbortSignal) => Promise<void>;
  deleteThread: (threadId: string, signal?: AbortSignal) => Promise<void>;
  markAsRead: (threadId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useThreadsStore = create<IThreadsStore>((set) => ({
  loading: false,
  error: null,
  threads: [],

  getThreads: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await MessagesApi.getThreads(signal);
      const userId = PermissionsUtils.getUserId();

      const threads = result.data.map((item) => ({
        ...item,
        replyReceiverId: userId === item.receiverId ? item.userId : item.receiverId,
      }));

      set({ threads, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Default),

  deleteThread: ApiUtils.wrapperApi(async (threadId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await MessagesApi.deleteMessageGroup(threadId, signal);
      const { getThreads } = useThreadsStore.getState();
      getThreads();
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  markAsRead: ApiUtils.wrapperApi(async (threadId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await MessagesApi.markGroupRead(threadId, signal);
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ threads: [], loading: false, error: null }),
}));
